import Image from 'next/image';
import styles from './LoadingMayz.module.scss';
import { MAYZ_LOGO } from '@/src/utils/images';

export default function LoadingMayz() {

    return (
        <div className={styles.body}>
            <div className={styles.bg}>
                <div className={styles.red}></div>
                <div className={styles.purple}></div>
            </div>
            <section className={styles.header}>
                <div className={styles.articleLeft}>
                    <div className={styles.logo}>
                        <Image src={MAYZ_LOGO} alt="logo" width="100%" height="100%" layout="responsive" objectFit="contain" priority />
                    </div>
                </div>
            </section>
        </div>
    );
}
